import {createAemClient} from '@uwm/aem';

export default createAemClient({
    graphqlEndpoint: 'dcxconnex-tips',
    damPath: 'dcxconnex/tips',
});
